<template>
	<div class="container py-4 py-md-6" v-if="products.length > 0">

		<div class="d-flex align-items-center justify-content-between">
			<h2 class="my-2">Liknande produkter</h2>
			<a href="#" class="d-none d-md-block text-decoration-none fw-bold" @click="selectProduct(null)">Se fler produkter</a>
		</div>


		<div class="row article-row-cols row-cols-2 row-cols-md-4 g-3 g-md-4 gy-4 mt-2">
			<div class="col" v-for="product in products" @click="selectProduct(product)">
				<div class="image-container">
					<img :src="product.attachments.attachment[0]['#text']" v-if="product.attachments && product.attachments.attachment[0]" />
				</div>

				<div class="title">
					{{ product.name }}
				</div>
			</div>
		</div>

		<div class="d-flex d-md-none justify-content-center mt-5 mb-4">
			<button class="btn btn-outline-secondary" type="button" @click="selectProduct(null)">Se fler produkter</button>
		</div>

	</div>
</template>

<script>

import mixins from './mixins'


export default {

	mixins: [mixins],


	data() {
		return {
			products: [],
		}
	},

	created () {
		this.emitter.on('setRelatedProducts', (products) => {
			this.products = products
		})
	},

	methods: {
		selectProduct (product) {
			this.emitter.emit('selectProduct', product)
		}
	}
}
</script>
